export const TWITTER_FORM_TITLE = 'X Ads Automation';
export const TWITTER_SERVICE_PATH = '/services/twitter';
